import React, {Dispatch, SetStateAction, useState, useEffect} from "react";
import * as Body from './Styles'
import * as functions from '../../utils/functions/functions'
import axios from "axios";
import Loading from "../../components/Loading/Loading";

import Input from '../../components/Input/Input'
import { useNavigate } from "react-router-dom";

import { Eye, EyeOff } from 'lucide-react'
import {useDispatch} from 'react-redux'
import CodeInput from "../../components/CodeInput/CodeInput";
import { USE_MOCK } from '../../utils/mock/mockFlag'
import { getApiBaseUrl } from '../../utils/defines/apiUrl'
import { getLogoByDomain } from '../../utils/functions/getLogoByDomain'

type LoginProps = {
    setEmailLogin: Dispatch<SetStateAction<string>>,
    setPasswordLogin: Dispatch<SetStateAction<string>>,
    toggleContent: Dispatch<SetStateAction<string>>,
    setName: Dispatch<SetStateAction<string>>,
    toggleLoading: Dispatch<SetStateAction<boolean>>
}

type AuthProps = {
    name: string,
    email: string,
    senha: string,
    toggleLoading: Dispatch<SetStateAction<boolean>>
}

const MOCK_EMAIL = 'mock@dhm.com'
const MOCK_SENHA = 'Mock@12345678'

const LoginContent: React.FC<LoginProps> = ({ setEmailLogin, setPasswordLogin, toggleContent, setName, toggleLoading }) => {
    const [email, setEmail] = useState(USE_MOCK ? MOCK_EMAIL : "")
    const [senha, setPassword] = useState(USE_MOCK ? MOCK_SENHA : "")
    const [seePassword, toggleSee] = useState(true)
    const [errorPass, toggleErrorPass] = useState(false)
    const [errorEmail, toggleErrorEmail] = useState(false)

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const login = () => {
        const verify = functions.checkCredentials(email, senha)
        if (!verify.email || !verify.password) {
            toggleErrorPass(!verify.email)
            toggleErrorEmail(!verify.password)
            return
        }
        toggleErrorPass(false)
        toggleErrorEmail(false)

        if (USE_MOCK) {
            if (email === MOCK_EMAIL && senha === MOCK_SENHA) {
                setEmailLogin(email)
                setPasswordLogin(senha)
                toggleContent("AUTH")
            } else {
                dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: '[MOCK] Email ou senha incorretos' })
            }
            return
        }

        loginRequest()
    }

    const loginRequest = () => {
        toggleLoading(true)
        axios.post(`${getApiBaseUrl()}/login`, { email, senha }, { withCredentials: true })
            .then(() => {
                setEmailLogin(email)
                setPasswordLogin(senha)
                toggleLoading(false)
                toggleContent("AUTH")
            })
            .catch((error) => {
                if (error.response.data.code === "TFA-3") {
                    toggleContent("AUTH")
                    toggleLoading(false)
                    return
                }
                toggleLoading(false)
                functions.ResolveErrors(error.response.status, error.response.data.code, error.response.data.message, navigate, dispatch, error.response.data.content)
            })
    }

    const forgotPassword = () => {
        const url = `https://www.conecta.tectrolnet.com.br/recuperar${email ? `?email=${encodeURIComponent(email)}` : ''}`
        window.open(url, '_blank')
    }

    return (
        <div onKeyDown={(e) => e.key === 'Enter' && login()}>
            {/* {USE_MOCK && (
                <p style={{ fontFamily: 'Nunito', fontSize: 12, color: '#E5D34A', opacity: 0.7, margin: '0 0 12px' }}>
                    Modo mock — correto: <strong>{MOCK_EMAIL}</strong> / <strong>{MOCK_SENHA}</strong>
                </p>
            )} */}
            <Input text={email} setText={setEmail} placeholder="EMAIL" error={errorEmail} />
            <Body.PasswordContent>
                <Input text={senha} setText={setPassword} secret={seePassword} placeholder="SENHA" error={errorPass} />
                <Body.Icon onClick={() => toggleSee(old => !old)}>
                    {seePassword ? <Eye size={18} /> : <EyeOff size={18} />}
                </Body.Icon>
            </Body.PasswordContent>
            <Body.ButtonLogin onClick={login}>Entrar</Body.ButtonLogin>
            <Body.TextBtn onClick={forgotPassword}>Esqueceu sua senha?</Body.TextBtn>
        </div>
    )
}

const AuthLogin: React.FC<AuthProps> = ({ name, email, senha, toggleLoading }) => {
    const navigate = useNavigate()
    const [codigo_tfa, setCode] = useState("")
    const dispatch = useDispatch()

    const isLogged = () => {
        try { localStorage.setItem("@logged", "true") } catch (e) { console.log(e) }
    }

    const sendAuth = () => {
        if (USE_MOCK) {
            if (codigo_tfa === '123456') {
                isLogged()
                navigate("/inicio")
            } else {
                dispatch({ type: 'ADD_NOTIFICATION', status: 3, title: '[MOCK] Código inválido — use 123456' })
            }
            return
        }

        toggleLoading(true)
        axios.post(`${getApiBaseUrl()}/login`, { email, senha, tfaCode: codigo_tfa }, { withCredentials: true })
            .then(() => {
                isLogged()
                navigate("/inicio")
                toggleLoading(false)
            })
            .catch((error) => {
                toggleLoading(false)
                functions.ResolveErrors(error.response.status, error.response.data.code, error.response.data.message, navigate, dispatch, error.response.data.content)
            })
    }

    const resendCode = () => {
        toggleLoading(true)
        axios.post(`${getApiBaseUrl()}/login`, { email, senha }, { withCredentials: true })
            .then(() => {
                toggleLoading(false)
                dispatch({ type: 'ADD_NOTIFICATION', status: 1, title: "Código reenviado com sucesso" })
            })
            .catch((error) => {
                toggleLoading(false)
                functions.ResolveErrors(error.response.status, error.response.data.code, error.response.data.message, navigate, dispatch, error.response.data.content)
            })
    }

    return (
        <div onKeyDown={(e) => e.key === 'Enter' && sendAuth()}>
            {/* {USE_MOCK && (
                <p style={{ fontFamily: 'Nunito', fontSize: 12, color: '#E5D34A', opacity: 0.7, margin: '0 0 8px' }}>
                    Modo mock — código correto: <strong>123456</strong> · qualquer outro dispara erro
                </p>
            )} */}
            <Body.InputTitle style={{ marginBottom: 0, fontSize: '16px' }}>
                Enviamos um código de segurança para seu e-mail via plataforma Conecta. Insira-o abaixo.
            </Body.InputTitle>
            <CodeInput setText={setCode} />
            <Body.ButtonLogin onClick={sendAuth}>Continuar</Body.ButtonLogin>
            <Body.TextBtn onClick={resendCode}>Reenviar código</Body.TextBtn>
        </div>
    )
}

const Login: React.FC = () => {
    const navigate = useNavigate()

    const [name, setName] = useState("")
    const [email, setEmailLogin] = useState("")
    const [password, setPasswordLogin] = useState("")
    const [content, toggleContent] = useState("LOGIN")
    const [loading, toggleLoading] = useState(false)

    useEffect(() => {
        let isMounted = true
        const getLogged = async () => {
            try {
                let isLogged = localStorage.getItem("@logged")
                if (isLogged) navigate("/inicio")
            } catch (error) {
            } finally {
                if (isMounted) toggleLoading(false)
            }
        }
        getLogged()
        return () => { isMounted = false }
    }, [])

    const getContent = () => {
        switch (content) {
            case "LOGIN":
                return <LoginContent setEmailLogin={setEmailLogin} setPasswordLogin={setPasswordLogin}
                    toggleContent={toggleContent} setName={setName} toggleLoading={toggleLoading} />
            case "AUTH":
                return <AuthLogin name={name} email={email} senha={password} toggleLoading={toggleLoading} />
        }
        return <></>
    }

    return <Body.Container>
        <div style={{ display: 'flex'}}>
            <div>
                <Body.Title>DHM4.0</Body.Title>
                <Body.Subtitle>App de monitoramento</Body.Subtitle>
            </div>
        </div>
        <Body.Card>
            <Body.CardTitle>Login</Body.CardTitle>
            {getContent()}
        </Body.Card>
        <Body.Logo src={getLogoByDomain()} />
        <Body.Blob1 />
        <Body.Blob2 />
        <Body.Blob3 />
        {loading ? <Loading /> : null}
    </Body.Container>
}

export default Login
